import { createSelector, createFeatureSelector } from '@ngrx/store';
import { adapter } from './category.entity';
import { CategoryState, categoryFeatureKey } from './category.state';

export const {
    selectAll,
    selectEntities,
    selectIds,
    selectTotal
  } = adapter.getSelectors();

export const getCategoryState = createFeatureSelector<CategoryState>(categoryFeatureKey);

export const getAllCategories = createSelector(getCategoryState, selectAll);

export const getCategoryById = (id: string) => createSelector(getCategoryState, state => state.entities[id]);

export const getError = createSelector(getCategoryState, state => state.error);

export const getTotalCount = createSelector(getCategoryState, state => state.totalCount);
